import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import {
  DvrOutlined,
  Diversity2Outlined,
  Healing,
  HomeOutlined,
  LocalPharmacyOutlined,
  DriveFileRenameOutline,
  MedicationOutlined,
  ImageOutlined,
  TaskOutlined,
  SentimentSatisfiedOutlined,
  RestaurantMenu,
  VerifiedUserOutlined,
  ExpandMore,
  MonitorHeartOutlined,
  MasksOutlined,
  SickOutlined,
  ErrorOutlineOutlined,
  VideocamOutlined,
  PsychologyOutlined,
  AutorenewOutlined,
} from '@mui/icons-material';
import { AiOutlineCalculator } from 'react-icons/ai';

import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRef: any;
}

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, coachRef } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      icon: <DvrOutlined />,
      label: '電子病歷卡',
    },
    {
      disabled: true,
      icon: <AutorenewOutlined />,
      label: 'SBAR',
      id: 'sbar',
    },
    {
      label: 'SBAR 1',
      toggle: toggle.sbar,
    },
    {
      label: 'SBAR 2',
      toggle: toggle.sbar,
    },
    {
      label: 'SBAR 3',
      toggle: toggle.sbar,
    },
    {
      icon: <Diversity2Outlined />,
      label: '護理交接 ',
    },
    {
      icon: <Healing />,
      label: '住院記錄',
    },
    {
      icon: <HomeOutlined />,
      label: '出院記錄',
    },
    {
      icon: <LocalPharmacyOutlined />,
      label: '病人狀況與處方',
    },
    {
      icon: <DriveFileRenameOutline />,
      label: '護理紀錄',
    },
    {
      icon: <MedicationOutlined />,
      label: '用藥記錄',
    },
    {
      icon: <ImageOutlined />,
      label: '放射攝影紀錄',
    },
    {
      icon: <TaskOutlined />,
      label: '臨床病理學',
    },
    {
      disabled: true,
      icon: <MonitorHeartOutlined />,
      label: '臨床觀察記錄',
      id: 'clinical_obv',
    },
    {
      label: '生命體徵記錄',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'I/O 輸液輸入',
      toggle: toggle.clinical_obv,
    },
    {
      label: '血糖記錄表',
      toggle: toggle.clinical_obv,
    },
    {
      label: '臨床觀察 (重症監護室)',
      toggle: toggle.clinical_obv,
    },
    {
      disabled: true,
      icon: <SentimentSatisfiedOutlined />,
      label: '患者評估',
      id: 'patient_evaluation',
    },
    {
      label: 'Morse 跌倒評估表',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '亨普蒂跌倒評估量表',

      toggle: toggle.patient_evaluation,
    },
    {
      label: '布雷登壓瘡風險評估量表',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '需求評估',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '兒童版GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'FOUR昏迷指數',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '患者安全報告',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '患者安全報告與學習系統',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '不良藥物反應報告系統',
      toggle: toggle.patient_evaluation,
    },

    {
      icon: <SickOutlined />,
      disabled: true,
      label: '疼痛評估',
      id: 'pain',
    },
    {
      label: 'NRS',
      toggle: toggle.pain,
    },
    {
      label: 'FLACC疼痛評估量表',
      toggle: toggle.pain,
    },
    // {
    //   label: 'CNPS',
    //   toggle: toggle.pain,
    // },
    {
      label: '足功能指數',
      toggle: toggle.pain,
    },
    {
      label: '膝關節損傷與骨關節炎結果評估量表',
      toggle: toggle.pain,
    },
    {
      label: '下肢功能評估量表',
      toggle: toggle.pain,
    },
    {
      label: '頸部殘疾指數',
      toggle: toggle.pain,
    },
    {
      label: 'STarT 背部筛查',
      toggle: toggle.pain,
    },
    {
      icon: <PsychologyOutlined />,
      disabled: true,
      label: '精神病學',
      id: 'mental_health',
    },
    {
      label: '心理健康記錄',
      toggle: toggle.mental_health,
    },
    {
      label: '貝克抑鬱量表',
      toggle: toggle.mental_health,
    },
    {
      label: '貝克焦慮量表',
      toggle: toggle.mental_health,
    },
    {
      label: '簡易精神狀態檢查',
      toggle: toggle.mental_health,
    },
    {
      disabled: true,
      icon: <MasksOutlined />,
      label: '特殊部分記錄',
      id: 'special',
    },
    {
      label: '手術',
      toggle: toggle.special,
    },
    {
      label: '麻醉记录',
      toggle: toggle.special,
    },
    {
      label: '输血',
      toggle: toggle.special,
    },
    {
      label: '插管',
      toggle: toggle.special,
    },
    {
      label: '心肺復甦',
      toggle: toggle.special,
    },
    {
      label: '透析',
      toggle: toggle.special,
    },
    {
      label: '急诊',
      toggle: toggle.special,
    },
    {
      label: '分娩',
      toggle: toggle.special,
    },
    {
      label: '居家护理记',
      toggle: toggle.special,
    },
    {
      icon: <RestaurantMenu />,
      label: '饮食与营养',
    },
    {
      disabled: true,
      icon: <VerifiedUserOutlined />,
      label: '協議',
      id: 'agreement',
    },
    {
      label: '患者指南',
      toggle: toggle.agreement,
    },
    {
      label: '一般病患同意書',
      toggle: toggle.agreement,
    },
    {
      label: '輸血',
      toggle: toggle.agreement,
    },
    {
      label: '清醒鎮靜',
      toggle: toggle.agreement,
    },
    {
      label: '拒絕維生醫療',
      toggle: toggle.agreement,
    },
    {
      label: '入院协议',
      toggle: toggle.agreement,
    },
    {
      label: '入院指南',
      toggle: toggle.agreement,
    },
    {
      label: '入院檢查清單',
      toggle: toggle.agreement,
    },
    {
      label: '跌倒預防教育',
      toggle: toggle.agreement,
    },
    {
      label: '持續性腎臟替代治療',
      toggle: toggle.agreement,
    },
    {
      label: '中心靜脈導管置放',
      toggle: toggle.agreement,
    },
    {
      label: '氣管插管',
      toggle: toggle.agreement,
    },
    {
      label: '身體約束同意書',
      toggle: toggle.agreement,
    },
    {
      disabled: true,
      icon: <ErrorOutlineOutlined />,
      label: '資訊學與護理',
      id: 'information',
    },
    {
      label: 'Generative AI Nursing Record',
      toggle: toggle.information,
    },
    {
      label: 'Chat GPT',
      toggle: toggle.information,
    },
    {
      label: 'Google Gemini',
      toggle: toggle.information,
    },
    {
      label: 'Cochranelibrary',
      toggle: toggle.information,
    },
    {
      label: 'JBI',
      toggle: toggle.information,
    },
    {
      label: 'DXPLAIN',
      toggle: toggle.information,
    },
    {
      label: 'Patientslikeme',
      toggle: toggle.information,
    },
    {
      label: 'Smartpatients',
      toggle: toggle.information,
    },
    {
      icon: <VideocamOutlined />,
      label: '影片上傳',
    },
    {
      icon: <AiOutlineCalculator />,
      label: '藥物計算器',
    },
  ];

  const onClickListItem = (label: string) => {
    if (!student_uuid) return onRequired('REQUIRED.STUDENT');

    if (label === '患者安全報告與學習系統') {
      window.open('https://psnet.ahrq.gov/');
      return;
    } else if (label === '不良藥物反應報告系統') {
      window.open('https://who-umc.org/');
      return;
    } else if (label === 'Generative AI Nursing Record') {
      window.open('https://chatbot2-enr-tw.streamlit.app/');
      return;
    } else if (label === 'Chat GPT') {
      window.open('https://chat.openai.com/chat');
      return;
    } else if (label === 'Google Gemini') {
      window.open('https://bard.google.com/');
      return;
    } else if (label === 'Cochranelibrary') {
      window.open('https://www.cochranelibrary.com/');
      return;
    } else if (label === 'JBI') {
      window.open('https://jbi.global/');
      return;
    } else if (label === 'DXPLAIN') {
      window.open('https://www.mghlcs.org/projects/dxplain');
      return;
    } else if (label === 'Patientslikeme') {
      window.open('https://www.patientslikeme.com/');
      return;
    } else if (label === 'Smartpatients') {
      window.open('https://www.smartpatients.com/');
      return;
    }

    if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    if (menuDrawerWidth !== 220) {
      if (sublabel) newToggle[sublabel] = true;
      setToggle(newToggle);
      setMenuDrawerWidth(220);
      return;
    }

    if (sublabel) newToggle[sublabel] = !newToggle[sublabel];
    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return (
            <ExpandMore
              fontSize="small"
              sx={{ color: '#fff', marginRight: '-8px' }}
            />
          );
        };

        // 축소된 메뉴 (52px)
        if (menuDrawerWidth !== 220) {
          if (!icon) return null;

          return (
            <Tooltip
              key={label}
              title={label}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                  },
                },
                arrow: {
                  sx: {
                    color: 'rgba(0, 0, 0, 0.9)',
                  },
                },
              }}
            >
              <ListItem disablePadding>
                <ListItemButton onClick={onClick}>
                  <ListItemIcon>{icon}</ListItemIcon>
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        }

        // 확장된 메뉴 (220px)
        if (icon) {
          return (
            <ListItem
              key={label}
              disablePadding
              ref={label === '特殊部分記錄' ? coachRef : null}
              sx={{ whiteSpace: 'pre-wrap' }}
            >
              <ListItemButton onClick={onClick}>
                <ListItemIcon sx={{ margin: '6.5px 0 6px 0' }}>
                  {icon}
                </ListItemIcon>
                <ListItemText sx={{ margin: '6.5px 0 0 0' }} primary={label} />
                <MoreIcon />
              </ListItemButton>
            </ListItem>
          );
        }

        if (toggle) {
          return (
            <ListItem key={label} disablePadding sx={{ width: '200px' }}>
              <ListItemButton onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} sx={{ whiteSpace: 'pre-wrap' }} />
                <MoreIcon />
              </ListItemButton>
            </ListItem>
          );
        }

        return null;
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
